import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';
import { useReadLocalStorage } from 'usehooks-ts';

import { home } from 'router/routes';
import { LOCAL_STORAGE_KEY, STRING_STORAGE_VALUE_OPTIONS } from 'constants/localStorage';

const UnauthorizedOnlyRoute = ({ component: Component, ...rest }) => {
  const authToken = useReadLocalStorage(LOCAL_STORAGE_KEY.AUTH_TOKEN, STRING_STORAGE_VALUE_OPTIONS);

  return (
    <Route
      {...rest}
      render={(props) =>
        authToken ? (
          <Redirect
            to={{
              pathname: home,
              state: { from: props.location },
            }}
          />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};

UnauthorizedOnlyRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func, PropTypes.any]).isRequired,
  location: PropTypes.shape({}),
};

export default UnauthorizedOnlyRoute;
